import React from 'react';
import ContactFooter from './ContactFooter';
import LogoFooter from './LogoFooter';
import OurServicesFooter from './OurServicesFooter';
import { DefaultFlex } from '../../Assistant/DefaultStyle';

function Footer() {
  return (
    <div className={`mt-20 pt-10 text-gray300 shadow-2xl shadow-gray400`}>
      <div
        className={`mx-auto lg:w-9/12 w-full flex flex-col lg:${DefaultFlex} lg:flex-row md:pb-4 pb-24`}
      >
        <LogoFooter />
        <OurServicesFooter />
        <ContactFooter />
      </div>
    </div>
  );
}

export default Footer;
